export default "__VITE_ASSET__ktWpTPBQ__"